(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire2957"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire2957"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jmFFy", function(module, exports) {

$parcel$export(module.exports, "initFAQ", function () { return $84c9ae54eae311c3$export$91c34452fd189695; });

var $koLG2 = parcelRequire("koLG2");
const $84c9ae54eae311c3$var$acordeonFeature = ()=>{
    const $faqContainer = document.querySelector('[data-js="faq"]');
    if (!$faqContainer) return;
    (0, $koLG2.initDetailsAccordion)($faqContainer, '[data-js="faq-item"]');
};
const $84c9ae54eae311c3$export$91c34452fd189695 = ()=>{
    $84c9ae54eae311c3$var$acordeonFeature();
};

});
parcelRegister("koLG2", function(module, exports) {

$parcel$export(module.exports, "initDetailsAccordion", function () { return $b12cef79cc123d2b$export$45b65a693d4d6ae1; });
/**
 * Makes a group of <details> elements inside a container behave like an accordion:
 * opening one automatically closes any other currently open element matching the selector.
 *
 * Uses a single delegated listener on the container instead of one per <details>,
 * so it also picks up elements added to the DOM later.
 *
 * Note: the native `toggle` event does not bubble, so the listener is registered
 * in the capture phase — capturing still fires for non-bubbling events.
 */ const $b12cef79cc123d2b$export$45b65a693d4d6ae1 = ($container, detailsSelector)=>{
    const isMatchingOpenDetails = ($target)=>$target instanceof HTMLDetailsElement && $target.matches(detailsSelector) && $target.open;
    $container.addEventListener('toggle', (event)=>{
        const $toggledDetails = event.target;
        if (!isMatchingOpenDetails($toggledDetails)) return;
        const $allDetails = $container.querySelectorAll(`${detailsSelector}[open]`);
        $allDetails.forEach(($details)=>{
            if ($details !== $toggledDetails) $details.removeAttribute('open');
        });
    }, true);
};

});


const $5a3e422eb87bfbda$export$5a4f39f307d529a5 = ()=>{
    const $infoHolders = document.querySelectorAll('.options-table__sign-holder');
    if ($infoHolders) {
        $infoHolders.forEach((holder)=>{
            holder.addEventListener('mouseover', ()=>{
                const info = holder.querySelector('.options-table__answer-info');
                if (info) info.hidden = false;
            });
        });
        $infoHolders.forEach((holder)=>{
            holder.addEventListener('mouseleave', ()=>{
                const info = holder.querySelector('.options-table__answer-info');
                if (info) info.hidden = true;
            });
        });
    }
};



var $jmFFy = parcelRequire("jmFFy");
(0, $5a3e422eb87bfbda$export$5a4f39f307d529a5)();
// initPartnersForm()
(0, $jmFFy.initFAQ)();

})();
//# sourceMappingURL=script.js.map
